/* eslint-disable no-case-declarations */
/* eslint-disable no-underscore-dangle */
/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';
import _ from 'underscore';
import { ImminenceTypes, ImminenceState, CommentsRequestState } from './types';

const INITIAL_STATE: ImminenceState = {
  get_imminence: {
    index: '',
    _id: 0,
    score: '',
    _source: [],
    currentPage: 1,
    postsPerPage: 10,
    total_entries: 0,
    total_imminence: {
      has_low_competition: 0,
      has_imminence: 0,
      has_desert: 0,
    },
    view_panel: 'has_imminence',
  },
  request: {
    loading: false,
    loaded: false,
    error: false,
  },
  search_imminence: {
    loading: false,
    loaded: false,
    error: false,
  },
  comments_imminence_request: {},
  comments: {},
  destroy_imminence_managed_request: { loading: false, loaded: false, error: false },
};

const INITIAL_STATE_COMMENT: CommentsRequestState = {
  get_comments: {
    loading: false,
    loaded: false,
    error: false,
  },
  create_comment: {
    loading: false,
    loaded: false,
    error: false,
  },
  destroy_comment: {
    loading: false,
    loaded: false,
    error: false,
  },
};

const reducer: Reducer<ImminenceState> = (
  state = INITIAL_STATE,
  { type, result, currentPage, page, biddingId, contactName, profileId, commentId },
) => {
  return produce(state, (draft) => {
    switch (type) {
      case ImminenceTypes.GET_DADOS_IMMINENCE_REQUEST:
        draft.request = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ImminenceTypes.GET_DADOS_IMMINENCE_SUCCESS:
        draft.get_imminence._source = result?.data?.imminences;
        draft.get_imminence.total_entries = result?.data?.total_rows;
        draft.get_imminence.total_imminence.has_low_competition =
          result?.data?.total_imminence[0]?.has_low_competition;
        draft.get_imminence.total_imminence.has_imminence =
          result?.data?.total_imminence[1]?.has_imminence;
        draft.get_imminence.total_imminence.has_desert =
          result?.data?.total_imminence[2]?.has_desert;

        draft.request = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ImminenceTypes.GET_DADOS_IMMINENCE_FAILURE:
        draft.request = {
          loading: false,
          loaded: false,
          error: true,
        };
        draft.get_imminence = INITIAL_STATE.get_imminence;
        break;
      case ImminenceTypes.SEARCH_IMMINENCE_REQUEST:
        draft.request = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ImminenceTypes.SEARCH_IMMINENCE_SUCCESS:
        draft.get_imminence._source = result?.data?.imminences;
        draft.get_imminence.total_entries = result?.data?.total_rows;
        draft.get_imminence.total_imminence.has_low_competition =
          result?.data?.total_imminence[0]?.has_low_competition;
        draft.get_imminence.total_imminence.has_imminence =
          result?.data?.total_imminence[1]?.has_imminence;
        draft.get_imminence.total_imminence.has_desert =
          result?.data?.total_imminence[2]?.has_desert;
        draft.request = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ImminenceTypes.SEARCH_IMMINENCE_FAILURE:
        draft.get_imminence = INITIAL_STATE.get_imminence;
        draft.request = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case ImminenceTypes.CREATE_COMMENT_REQUEST:
        draft.comments_imminence_request[biddingId] = {
          ...INITIAL_STATE_COMMENT,
          create_comment: {
            ...INITIAL_STATE_COMMENT.create_comment,
            loading: true,
          },
        };
        draft.comments_imminence_request[biddingId] = {
          ...INITIAL_STATE_COMMENT,
          create_comment: {
            ...INITIAL_STATE_COMMENT.create_comment,
            loading: true,
          },
        };
        break;
      case ImminenceTypes.GET_COMMENTS_REQUEST:
        draft.comments_imminence_request[biddingId] = {
          ...INITIAL_STATE_COMMENT,
          get_comments: {
            ...INITIAL_STATE_COMMENT.get_comments,
            loading: true,
          },
        };
        break;

      case ImminenceTypes.GET_COMMENTS_SUCCESS:
        draft.comments_imminence_request[biddingId] = {
          ...INITIAL_STATE_COMMENT,
          get_comments: {
            ...INITIAL_STATE_COMMENT.get_comments,
            loaded: true,
          },
        };

        draft.comments[biddingId] = result.data?.data ? [] : result.data;

        break;

      case ImminenceTypes.GET_COMMENTS_FAILURE:
        draft.comments_imminence_request[biddingId] = {
          ...INITIAL_STATE_COMMENT,
          get_comments: {
            ...INITIAL_STATE_COMMENT.get_comments,
            error: true,
          },
        };
        break;
      case ImminenceTypes.CREATE_COMMENT_SUCCESS: {
        draft.comments_imminence_request[biddingId] = {
          ...INITIAL_STATE_COMMENT,
          create_comment: {
            ...INITIAL_STATE_COMMENT.create_comment,
            loaded: true,
          },
        };
        const comment = {
          id: result.data.id,
          message: result.data.message,
          created_at: result.data.created_at,
          contact_client: {
            id: profileId,
            nome: contactName,
          },
        };

        const biddingIndex = state.get_imminence._source.findIndex(
          (bidding) => bidding._source.id === biddingId,
        );

        draft.get_imminence._source[biddingIndex]._source.comments = [
          ...draft.get_imminence._source[biddingIndex]._source.comments,
          comment,
        ];

        break;
      }

      case ImminenceTypes.CREATE_COMMENT_FAILURE:
        draft.comments_imminence_request[biddingId] = {
          ...INITIAL_STATE_COMMENT,
          create_comment: {
            ...INITIAL_STATE_COMMENT.create_comment,
            error: true,
          },
        };
        break;
      case ImminenceTypes.DESTROY_COMMENT_REQUEST:
        draft.comments_imminence_request[biddingId] = {
          ...INITIAL_STATE_COMMENT,
          destroy_comment: {
            ...INITIAL_STATE_COMMENT.destroy_comment,
            loading: true,
          },
        };
        break;

      case ImminenceTypes.DESTROY_COMMENT_SUCCESS:
        draft.comments_imminence_request[biddingId] = {
          ...INITIAL_STATE_COMMENT,
          destroy_comment: {
            ...INITIAL_STATE_COMMENT.destroy_comment,
            loaded: true,
          },
        };

        const biddingIndex = state.get_imminence._source.findIndex(
          (bidding) => bidding._source.id.toString() === biddingId,
        );

        draft.get_imminence._source[biddingIndex]._source.comments = [
          ...draft.get_imminence._source[biddingIndex]._source.comments.filter(
            (comment) => comment.id !== commentId,
          ),
        ];

        break;

      case ImminenceTypes.CREATE_BIDDING_FAVORITE_SUCCESS:
        const createFavoriteBiddingIndex = state.get_imminence._source.findIndex(
          (bidding) => bidding._source.id === biddingId,
        );

        draft.get_imminence._source[createFavoriteBiddingIndex]._source.favorited = true;
        draft.get_imminence._source[createFavoriteBiddingIndex]._source.favorited_by = _.uniq([
          ...state.get_imminence._source[createFavoriteBiddingIndex]._source.favorited_by,
          contactName,
        ]);
        break;

      case ImminenceTypes.DESTROY_BIDDING_FAVORITE_SUCCESS:
        const destroyFavoriteBiddingIndex = state.get_imminence._source.findIndex(
          (bidding) => bidding._source.id === biddingId,
        );

        draft.get_imminence._source[destroyFavoriteBiddingIndex]._source.favorited = false;
        draft.get_imminence._source[destroyFavoriteBiddingIndex]._source.favorited_by =
          state.get_imminence._source[destroyFavoriteBiddingIndex]._source.favorited_by.filter(
            (contacts) => contacts !== contactName,
          );
        break;
      case ImminenceTypes.CREATE_BIDDING_MANAGED_SUCCESS:
        const createManagedBiddingIndex = state.get_imminence._source.findIndex(
          (bidding) => bidding._source.id === biddingId,
        );

        draft.get_imminence._source[createManagedBiddingIndex]._source.managed = true;
        break;

      case ImminenceTypes.DESTROY_BIDDING_MANAGED_REQUEST:
        draft.destroy_imminence_managed_request.loading = true;
        draft.destroy_imminence_managed_request.loaded = false;
        draft.destroy_imminence_managed_request.error = false;
        break;

      case ImminenceTypes.DESTROY_BIDDING_MANAGED_SUCCESS:
        const destroyManagedBiddingIndex = state.get_imminence._source.findIndex(
          (bidding) => bidding._source.id === biddingId,
        );

        if (destroyManagedBiddingIndex > -1) {
          draft.get_imminence._source[destroyManagedBiddingIndex]._source.managed = false;
        }

        draft.destroy_imminence_managed_request.loading = false;
        draft.destroy_imminence_managed_request.loaded = true;
        draft.destroy_imminence_managed_request.error = false;
        break;

      case ImminenceTypes.DESTROY_BIDDING_MANAGED_FAILURE:
        draft.destroy_imminence_managed_request.loading = false;
        draft.destroy_imminence_managed_request.loaded = false;
        draft.destroy_imminence_managed_request.error = true;
        break;

      case ImminenceTypes.UPDATE_CURRENT_PAGE:
        draft.get_imminence.currentPage = currentPage;
        break;
      case ImminenceTypes.SHOW_PAGE:
        draft.get_imminence.view_panel = page;
        break;
      default:
    }
  });
};
export default reducer;
